import { useRef, useState } from 'react'

import { GuestInboxTimelineAttachment } from '@new/domains/operations/components/StayTimeline/StayTimeline.types'

// Each refresh brings a new presigned link for the same file; showing a stable one stops
// photos and videos from reloading.
export const useStableAttachmentUrls = () => {
  const firstUrls = useRef<Record<string, string>>({})
  const [retryUrls, setRetryUrls] = useState<Record<string, string>>({})
  const [failedUrls, setFailedUrls] = useState<string[]>([])

  const getUrl = (attachment: GuestInboxTimelineAttachment) => {
    firstUrls.current[attachment.id] ??= attachment.url
    return retryUrls[attachment.id] ?? firstUrls.current[attachment.id]
  }

  const hasFailed = (attachment: GuestInboxTimelineAttachment) => {
    return failedUrls.includes(getUrl(attachment))
  }

  // A stable link that expired gets one more try with the latest one before giving up.
  const handleLoadError = (attachment: GuestInboxTimelineAttachment) => {
    const src = getUrl(attachment)

    if (src !== attachment.url) {
      setRetryUrls(urls => ({ ...urls, [attachment.id]: attachment.url }))
      return
    }

    setFailedUrls(urls => [...urls, src])
  }

  return { getUrl, hasFailed, handleLoadError }
}
